import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";

/** Stands in for a breakdown table the server could not compute. */
const BreakdownUnavailable = () => {
  const { t } = useTranslation();
  return (
    <Text as="div" data-test="kpi-breakdown-unavailable" variant="smBodySecondary">
      {t("kpisV2.breakdownUnavailable")}
    </Text>
  );
};

export default BreakdownUnavailable;
